<template>
    <v-card height="90%" width="97%" class="ma-3" flat>


        <v-card-title>

            <v-spacer>
            </v-spacer>
            <v-text-field v-model="search" label="Search by kiosk" single-line hide-details clearable @keyup.enter="fetchData(false)" @click:clear="fetchData(true)"></v-text-field>
            <!--<v-btn color="primary" @click="fetchData">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>-->
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="downloadExcel">
                <v-icon>mdi-download</v-icon>
            </v-btn>

        </v-card-title>

        <v-data-table fixed-header :headers="headers" :items="items" item-key="idVente" :options.sync="options"
            :server-items-length="totalItems" :items-per-page="itemsPerPage" :page="page" :footer-props="{
                'items-per-page': itemsPerPage,
                'page': page,
                'total-items': totalItems,
                'items-per-page-options': [5,50, 100, 150, { text: 'All', value: -1 }]
            }" @update:page="onPageChange" @update:items-per-page="onItemsPerPageChange" @update:options="fetchData(false)" class="elevation-1">

            <template v-slot:[`item.kiosk`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            {{ item.kiosk }}
                        </span>
                    </template>
                    <span>{{ getKioskName(item.kiosk) }}</span>
                </v-tooltip>
            </template>

            <template v-slot:[`item.message`]="{ item }">
                <span :style="{ color: item.message.includes(`HASN'T`) ? 'red' : 'green' }">
                    {{ item.message }}
                </span>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { store } from "@/models/Store.js";
import * as XLSX from 'xlsx';

export default {
    data() {
        return {
            showDetails: false,
            showPoidsFinaux: false,
            search: "",
            headers: [
                { text: 'Date', value: 'date' },
                { text: 'Kiosk', value: 'kiosk' },
                { text: 'Message', value: 'message' },               
            ],
            items: [],
            page: 1,
            itemsPerPage: 5,
            totalItems: 0,
            totalPages: 0,
            kiosksNames: [],
            options: {
                page: 1,
                itemsPerPage: 5,
                search: "",
                sortBy: [],      // colonne utilisée pour le tri
                sortDesc: [],
            }
        };
    },

    methods: {
        // Charger les données avec la pagination
        async fetchData(resetPage = false) {
            try {
                if (resetPage) {
                    this.page = 1;
                    this.itemsPerPage = 10;
                    this.search = '';
                    this.options = {
                        page: 1,
                        itemsPerPage: 10,
                        search: "",
                        sortBy: [],      // colonne utilisée pour le tri
                        sortDesc: [],
                    };
                } else {
                    this.options.search = this.search;
                }

                const { page, itemsPerPage, search, sortBy, sortDesc } = this.options

                await store.getLogEnergyCardByPagination(page, itemsPerPage, search, sortBy[0], sortDesc[0]);
                const response = store.state.logEnergyCard; 
                this.items = response.items;  
                this.totalItems = response.totalItems;  
                this.totalPages = response.totalPages;  
                this.page = response.currentPage;

            } catch (error) {
                console.error("Erreur lors de la récupération des données:", error);
            }
        },

        // Gérer le changement de page
        onPageChange(newPage) {
            this.page = newPage;
            this.fetchData();
        },

        // Gérer le changement du nombre d'éléments par page
        onItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.fetchData();
        },

        downloadExcel() {
            // Préparer les données pour l'exportation
            const formattedData = this.items.map((item) => {
                return {
                    kiosk: item.kiosk,
                    date: item.date,
                    message: item.message,
                };
            });

            const ws = XLSX.utils.json_to_sheet(formattedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Données');

            XLSX.writeFile(wb, 'donnees.xlsx');
        },
        async getKiosksNames() {
            await store.getKiosksNames();
            this.kiosksNames = store.state.kiosksNames;
            console.log("this.kiosksNames.length" + this.kiosksNames.length);
        },
        getKioskName(value) {
            const kiosk = this.kiosksNames.find(k => k.idExtranet === value.toString());
            return kiosk ? kiosk.name : value;
        },
    },
    mounted() {
        this.getKiosksNames();
        this.fetchData();
    },
};
</script>
